import { useEffect, useState } from "react";
import Tab from "../../Components/Molecules/Tabs";
import IndexReminders from "./Reminders/IndexReminders";
import IndexMaster from "./Master/IndexMaster";
import OtherSettingsForm from "./OtherSettings/OtherSettingsForm";
import IndexCustomRoles from "./CustomRoles/IndexCustomRoles";
import { getSettingsRequest } from "../../Redux/Settings/SettingsActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { hasPermission } from "../../Utils/getters";
import { MODULES, ROLE_BY_PERMISSIONS } from "../../Constant";

const Settings = () => {
  const { getUserResponse } = useSelector((state) => state.user);
  const [selectedTab, setSelectedTab] = useState("");

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };

  const TABS_VALUE = {
    MASTER: "master",
    CUSTOM_ROLES: "custom_roles",
    REMINDER_INTERVAL: "reminder_interval",
    OTHER_SETTINGS: "other_settings",
  };

  const TABS = [
    {
      label: "Master",
      value: TABS_VALUE.MASTER,
      action: "MASTER",
      permission: hasPermission(
        [ROLE_BY_PERMISSIONS[MODULES.MASTER_SETTINGS].SHOW_MASTER_SETTINGS],
        getUserResponse?.data
      ),
    },
    {
      label: "Custom Roles",
      value: TABS_VALUE.CUSTOM_ROLES,
      action: "ROLES",
      permission: hasPermission(
        [ROLE_BY_PERMISSIONS[MODULES.CUSTOM_ROLES].SHOW_CUSTOM_ROLES],
        getUserResponse?.data
      ),
    },
    {
      label: "Reminders",
      value: TABS_VALUE.REMINDER_INTERVAL,
      action: "REMINDERS",
      permission: hasPermission(
        [ROLE_BY_PERMISSIONS[MODULES.REMINDERS].SHOW_REMINDERS],
        getUserResponse?.data
      ),
    },
    {
      label: "Other Settings",
      value: TABS_VALUE.OTHER_SETTINGS,
      action: "OTHERS",
      permission: hasPermission(
        [ROLE_BY_PERMISSIONS[MODULES.OTHER_SETTINGS].SHOW_OTHER_SETTINGS],
        getUserResponse?.data
      ),
    },
  ];

  const renderTabContent = () => {
    switch (selectedTab) {
      case TABS_VALUE.MASTER:
        return <IndexMaster />;
      case TABS_VALUE.CUSTOM_ROLES:
        return <IndexCustomRoles />;
      case TABS_VALUE.REMINDER_INTERVAL:
        return <IndexReminders />;
      case TABS_VALUE.OTHER_SETTINGS:
        return <OtherSettingsForm />;
      default:
        return null;
    }
  };

  const [tabs, setTabs] = useState([]);

  useEffect(() => {
    if (getUserResponse?.data) {
      const res = TABS.filter((e) => e.permission);
      setTabs(res);
      if (res.length > 0 && !selectedTab) {
        setSelectedTab(res[0].value);
      }
    }
  }, [getUserResponse]);

  return (
    <>
      <div className="cntr">
        <h6 style={{ marginBottom: "20px" }}>SETTINGS & CONFIGURATION</h6>

        <div className="hdrComp">
          <div>
            <Tab
              tabs={tabs}
              selectedTab={selectedTab}
              handleTabChange={handleTabChange}
            />
          </div>
        </div>

        {renderTabContent()}
      </div>
    </>
  );
};

export default Settings;
